define('views/modules/profile/edit/preferences-edit-content-personal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // events
    'services/events/user-events',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/modules/profile/edit/preferences-edit-form-personal',
    // templates
    'text!templates/modules/profile/edit/preferences-edit-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // events
    UserEvents,
    // views
    VForm,
    VMenuSaveAction,
    VPreferencesEditFormPersonal,
    // templates
    TPreferencesEditContent
) {

    var VPreferencesEditContentPersonal = VForm.extend({
        fields: ['units', 'nameFormat', 'emails', 'emailsSupervisor', 'mainGroup', '_mainGroupId', 'customDataDefIds', 'pushNotifications'],
        template: TPreferencesEditContent,

        regions: {
            root: "#preferences-edit-content",
            menu: ".menu-actions",
            form: ".preferences-edit-form",
        },

        initialize: function(opt) {

            var model = this.model,
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveButton,
                        saveText: "Save",
                        radio: false,
                        tooltip: { container: this.regions.root, }
                    }),
                    form: new VPreferencesEditFormPersonal({
                        model: model,
                        group: opt.group
                    })
                };

            this.listenTo(model, { 'change': this.onModelChange });
            this.listenTo(this.view.form, 'disconnected connected', this.onSuccess);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form);

            return this;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSaveButton: function() {
            this.submit();
        },

        onSuccess: function() {
            var master = this.modelMaster,
                model = this.model;
            UserEvents.profileUpdate(model);

            if (model.getMainGroupId() !== master.getMainGroupId()) {
                User.fetch({ force: true });
            }

            this.trigger('back');
        },
    });

    return VPreferencesEditContentPersonal;
});

